module.exports = __webpack_public_path__ + "static/media/6.2583e684.jpg";